var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.60546 3.75068L20.3961 3.75189C20.5585 3.7515 20.7177 3.80198 20.8549 3.89742C20.9921 3.99285 21.1017 4.12928 21.1708 4.29069C21.2398 4.4521 21.2656 4.6318 21.245 4.80872C21.2243 4.98563 21.1582 5.15241 21.0543 5.2895L15.7503 12.3514C15.6246 12.5196 15.5558 12.7303 15.5554 12.9479L15.5549 19.3179C15.5548 19.4772 15.5178 19.634 15.4472 19.7732C15.3766 19.9124 15.2749 20.0296 15.1516 20.1136C15.0283 20.1976 14.8875 20.2457 14.7425 20.2534C14.5976 20.261 14.4533 20.2279 14.3232 20.1572L10.9219 18.3029C10.7797 18.2256 10.6599 18.1062 10.576 17.9582C10.4922 17.8102 10.4476 17.6395 10.4473 17.4651L10.4424 12.9425C10.4421 12.7254 10.3732 12.5152 10.2476 12.3476L4.94702 5.28818C4.84282 5.15118 4.77643 4.98434 4.75566 4.8073C4.73489 4.63027 4.76061 4.4504 4.82978 4.28887C4.89896 4.12734 5.00871 3.99087 5.14613 3.89552C5.28355 3.80018 5.44291 3.74992 5.60546 3.75068V3.75068ZM11.8343 11.881C11.9009 11.9696 11.9373 12.0809 11.9374 12.1958L11.943 17.0274L14.0623 18.1776L14.0628 12.1959C14.0629 12.0811 14.0994 11.9698 14.1659 11.8812L19.0395 5.39178L6.96183 5.39079L11.8343 11.881Z",
    fill: "#505255"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.5,
    height: 16.5,
    fill: "white",
    transform: "matrix(-1 -8.19735e-05 -8.19735e-05 1 21.25 3.75195)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter24Px);
export default __webpack_public_path__ + "static/media/filter_24px.714241d127592b19097728b8ca7afe02.svg";
export { ForwardRef as ReactComponent };